export const configSSO = {
    issuer: 'https://sts.inforius.be',
    postLogoutRedirectUri: 'https://ivalves.myinforius.be',
    redirectUri: 'https://ivalves.myinforius.be/callback',
    clientId: 'ivalves_admin',
    oidc: true,
    userinfoEndpoint: 'https://sts.inforius.be/connect/userinfo',
    useSilentRefresh: true,
    scope: 'openid profile email ivalves.api:admin',
    showDebugInformation: false,
    silentRefreshRedirectUri: 'https://ivalves.myinforius.be/silent-renew.html',
    responseType: 'code',
    enableLogConsole: false
};